/* src/app/components/dialogs/service-scaling/service-scaling-dialog.component.scss */
/*# sourceMappingURL=service-scaling-dialog.component.css.map */
